const alreadyPlural = ['media']

export function pluralize(noun: string, count: number, ending = 's') {
  if (alreadyPlural.includes(noun.toLowerCase())) return noun
  return `${noun}${count > 1 ? ending : ''}`
}
